import GUI from 'lil-gui'
import Stats from 'stats.js'

/**
 * Debug tooling, only mounted when the URL hash is `#debug`.
 * Exposes a lil-gui panel and an FPS/ms stats meter.
 */
export default class Debug {
  public readonly active: boolean
  public ui?: GUI
  public stats?: Stats

  constructor() {
    this.active = window.location.hash === '#debug'

    if (!this.active) return

    this.ui = new GUI({ title: 'cs-treejs · debug' })

    this.stats = new Stats()
    this.stats.showPanel(0) // 0: fps, 1: ms, 2: mb
    this.stats.dom.style.left = 'auto'
    this.stats.dom.style.right = '0'
    document.body.appendChild(this.stats.dom)
  }

  public destroy(): void {
    this.ui?.destroy()
    this.stats?.dom.remove()
  }
}
